'use client';

import React from 'react';
import { ExperienceType } from '../types';
import { typography } from '@/design-system/tokens/typography';

interface ExperiencePoliciesProps {
  experience: unknown;
  type: ExperienceType;
}

export const ExperiencePolicies: React.FC<ExperiencePoliciesProps> = ({
  experience,
  type,
}) => {
  if (!experience || type !== 'stay') return null;

  const getPolicies = () => {
    const exp = experience as {
      policies?: string[];
      cancellationPolicy?: string;
      checkIn?: string;
      checkOut?: string;
    };
    return exp?.policies || [];
  };

  const policies = getPolicies();
  const exp = experience as {
    cancellationPolicy?: string;
    checkIn?: string;
    checkOut?: string;
  };

  if (policies.length === 0 && !exp.cancellationPolicy && !exp.checkIn) {
    return null;
  }

  return (
    <div className='space-y-4'>
      <h2
        className='font-semibold text-gray-900'
        style={{
          fontSize: typography.size.lg, // 18px
          fontFamily: typography.fonts.primary,
          lineHeight: 'normal',
        }}
      >
        Policies
      </h2>
      <div className='space-y-4'>
        {exp.checkIn && (
          <div>
            <h3 className='font-medium text-gray-900 mb-1'>Check-in</h3>
            <p className='text-gray-700'>{exp.checkIn}</p>
          </div>
        )}
        {exp.checkOut && (
          <div>
            <h3 className='font-medium text-gray-900 mb-1'>Check-out</h3>
            <p className='text-gray-700'>{exp.checkOut}</p>
          </div>
        )}
        {exp.cancellationPolicy && (
          <div>
            <h3 className='font-medium text-gray-900 mb-1'>
              Cancellation Policy
            </h3>
            <p className='text-gray-700'>{exp.cancellationPolicy}</p>
          </div>
        )}
        {policies.length > 0 && (
          <div>
            <h3 className='font-medium text-gray-900 mb-2'>Other Policies</h3>
            <div className='space-y-2'>
              {policies.map((policy, index) => (
                <div key={index} className='flex items-start gap-2'>
                  <svg
                    width='16'
                    height='16'
                    viewBox='0 0 16 16'
                    fill='none'
                    className='text-blue-600 mt-0.5 flex-shrink-0'
                  >
                    <path d='M8 2L9.5 6L8 10L6.5 6L8 2Z' fill='currentColor' />
                  </svg>
                  <p className='text-gray-700'>{policy}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
